/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import TableComponent from "../../components/TableComponent";
import { GridColDef } from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";
import TeamDocumentModal from "../../Modals/teamDocument";
import RejectReasonModal from "../../Modals/rejectReason";
import { Booking } from "../../types/General";
import moment from "moment";
import { useAcceptRejectBookingMutation } from "../../services/booking";
import { showToast, showWarning } from "../../constants/toasts";
import { REQUEST_STATUS } from "../../utils/enums";
import {
  Box,
  Button,
  Card,
  Chip,
  IconButton,
  MenuItem,
  Select,
  Switch,
  Tooltip,
  Typography,
} from '@mui/material';

type bookingData = {
  data: Booking[];
  totalCount: number;
  page: number;
  handlePageChange?: any;
  venueStorageType?: "Venue" | "Storage";
  getVenueOwnerApi?:any
  showStatusColumn?: boolean;

};
const BookingList = ({
  data,
  totalCount,
  page,
  handlePageChange,
  venueStorageType,
  getVenueOwnerApi,
  showStatusColumn,
}: bookingData) => {
  const navigate = useNavigate();

  const [userDataState, setUserDataState] = useState(data);
  const [rows,setRows]=useState(data)
 const isVenue = venueStorageType === "Venue";

  useEffect(() => {
    setUserDataState(data);
  }, [data]);
  const label = { inputProps: { "aria-label": "Switch demo" } };
  const [updateBooking]=useAcceptRejectBookingMutation()

  const [rejectModalOpen, setRejectModalOpen] = useState(false);
  const [pendingBookingId, setPendingBookingId] = useState<string | undefined>(undefined);
  const [pendingStatus, setPendingStatus] = useState<keyof typeof REQUEST_STATUS | undefined>(undefined);



  const changeBookingStatus = async (
    statusValue: keyof typeof REQUEST_STATUS,
    id: string,
    rejectReason?: string
  ) => {
    try {
      const body: any = { bookingStatus: statusValue };
      if (statusValue === REQUEST_STATUS.REJECTED && rejectReason) {
        body.rejectReason = rejectReason;
      }
      const response = await updateBooking({
        body,
        id,
      }).unwrap();

      if (response?.statusCode === 200) {
        showToast(response?.message || 'Status updated');
   getVenueOwnerApi()
        setUserDataState((prev: any) =>
          (prev || []).map((item: any) =>
            (item?._id || item?.id) === id
              ? { ...item, bookingStatus: statusValue }
              : item
          )
        );
     
      }
    } catch (e: any) {
      showWarning(e?.data?.message || 'Failed to update status');
    }
  };
 
  const columns: GridColDef<(typeof rows )[number]>[] = [
    {
      minWidth: 90,
      field: "srNo",
      headerName: "Sr No",
      editable: false,
      sortable: false,
      align: "center",
      headerAlign: "center",
      renderCell: (params: any) => {
        const api: any = params.api;
        const index =
          (api?.getRowIndexRelativeToVisibleRows
            ? api.getRowIndexRelativeToVisibleRows(params.id)
            : api?.getSortedRowIds
            ? api.getSortedRowIds().indexOf(params.id)
            : (api?.getAllRowIds?.() || []).indexOf(params.id)) + 1;
        return <strong>{index > 0 ? index : 1}</strong>;
      },
    },
    {
      flex: 1,
      minWidth: 180,
      field: "bookingId",
      headerName: "Booking Id",
      editable: false,
      sortable: false,
      renderCell: ({ row }: any) => {
        return (
          <div className="user_block click_action" >
            <p>
              <b>{row?.transactionId || "N/A"}</b>
            </p>
          </div>
        );
      },
    },
    {
      flex: 1,
      minWidth: 240,
      field: "name",
      headerName: "Venue Name",
      editable: false,
      sortable: false,
      renderCell: ({ row }: any) => {
        return (
          <div
            className="user_block click_action"
           onClick={() =>
                  navigate(
                    `/manage-venue-owners/details/${row?.venueStorage?._id}?type=${
                      isVenue ? "Venue" : "Storage"
                    }`
                  )
                }
          >
            <p>
              <b>{row?.venueStorage?.name}</b>
            </p>
          </div>
        );
      },
    },
    
    {
      flex: 1,
      minWidth: 180,
      field: "profession",
      headerName: "User",
      editable: false,
      sortable: false,
      renderCell: ({ row }: any) => {
        return (
          <div
            className="user_block click_action"
            onClick={() => navigate(`/manage-booking/detail/${row?._id}`)}
          >
            <figure>
              <img
                src={row?.user?.image || "/static/images/user_placeholder.png"}
                alt=""
              />
            </figure>
            <p>
              <b>{row?.user?.name}</b>{" "}
              <span>{`${row?.user?.countryCode} ${row?.user?.phoneNumber}`}</span>{" "}
              <span>{row?.user?.email}</span>{" "}
            </p>
          </div>
        );
      },
    },

    {
      minWidth: 150,
      field: "completedJobs",
      headerName: "Date & Time",
      editable: false,
      sortable: false,
      align: "center",
      headerAlign: "center",
      renderCell: ({ row }: any) => {
        return (
          <div className="user_block click_action">
            <p>
              <b>
                {moment(row?.from).isSame(row?.to, "day")
                  ? moment(row?.from).format("MMM DD")
                  : `${moment(row?.from).format("MMM DD")} - ${moment(
                      row?.to
                    ).format("MMM DD")}`}
              </b>
            </p>
          </div>
        );
      },
    },
    

    {
      minWidth: 150,
      field: "earnings",
      headerName: "Total Price",
      editable: false,
      sortable: false,
      align: "center",
      headerAlign: "center",
      renderCell: ({ row }: any) => {
        const amount = row?.couponCode ? (row?.amount ?? row?.totalAmount) : row?.totalAmount;
        return <p className="c_success"><strong>{`$${amount || 0}`}</strong></p>;
      },
    },
   {
      minWidth: 150,
      field: "bookingStatus",
      headerName: "Booking Status",
      editable: false,
      sortable: false,
      align: "center",
      headerAlign: "center",
      renderCell: ({ row }: any) => {
        const current = (row?.bookingStatus || REQUEST_STATUS.PENDING).toString().toUpperCase();
        return (
          <Select
            value={current}
            onChange={(e) => {
              const selectedValue = String(e.target.value).toUpperCase() as keyof typeof REQUEST_STATUS;
              if (selectedValue === REQUEST_STATUS.REJECTED) {
                setPendingBookingId(row?._id || row?.id);
                setPendingStatus(selectedValue);
                setRejectModalOpen(true);
              } else {
                changeBookingStatus(selectedValue as any, row?._id || row?.id);
              }
            }}
            size="small"
          >
            <MenuItem value={REQUEST_STATUS.PENDING}>PENDING</MenuItem>
            <MenuItem value={REQUEST_STATUS.APPROVED}>APPROVED</MenuItem>
            <MenuItem value={REQUEST_STATUS.REJECTED}>REJECTED</MenuItem>
          </Select>
        );
      },
    },

    {
      minWidth: 130,
      field: "action",
      headerName: "Action",
      editable: false,
      sortable: false,
      renderCell: ({row}) => {
        return (
          <div className="table_actions v2">
            <Box>
              <IconButton
               onClick={() => navigate(`/manage-booking/detail/${row?._id}`)}
              >
                <img src="/static/images/eye_icon.svg" alt="" />
              </IconButton>
            </Box>
           
          </div>
        );
      },
    },
  ];
  let hidden = ["fullName"];
  if (!showStatusColumn) hidden.push("bookingStatus");

  const [open, setOpen] = useState(false);
  const handleCloseModal = () => {
    setOpen(false);
  };

  return (
    <>
      <div className="sorting_table">
        <TableComponent
          columns={columns?.filter((item) => !hidden.includes(item.field))}
          rows={userDataState}
          count={totalCount}
          page={page}
          onPageChange={handlePageChange}
        />
      </div>

      <TeamDocumentModal
        open={open}
        onClose={handleCloseModal}
        setOpen={setOpen}
      />
      <RejectReasonModal
        open={rejectModalOpen}
        onClose={() => setRejectModalOpen(false)}
        setOpen={setRejectModalOpen}
        onSubmit={(reason: string) => {
          if (pendingBookingId && pendingStatus) {
            changeBookingStatus(pendingStatus as any, pendingBookingId, reason);
          }
          setRejectModalOpen(false);
          setPendingBookingId(undefined);
          setPendingStatus(undefined);
        }}
      />
    </>
  );
};

export default BookingList;
